import { render, staticRenderFns } from "./VendorProfileIndex.vue?vue&type=template&id=2d450fd6"
import script from "./VendorProfileIndex.vue?vue&type=script&lang=js"
export * from "./VendorProfileIndex.vue?vue&type=script&lang=js"
import style0 from "./VendorProfileIndex.vue?vue&type=style&index=0&id=2d450fd6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports